import useRouter from 'hooks/useRouter';
import ChargeVehicleDetailView from '../../components/ChargeVehicleDetailView';

ChargeVehicleDetailScreen.propTypes = {};

function ChargeVehicleDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const vehicleId = router.query?.chargeVehicleId;
  const initialVehicle = router.location?.state?.vehicle ?? null;

  return <ChargeVehicleDetailView vehicleId={vehicleId} initialVehicle={initialVehicle} />;
}

export default ChargeVehicleDetailScreen;
